import useDataLoader from "./useDataLoader";

export { useDataLoader };
